<template>
  <v-card color="rgb(247, 247, 247)" width="100%" class="card d-flex align-center" elevation="0" dark>
    <v-card-text>
      <v-row style="width: 105%;">
        <v-col :cols="isMobile ? 12 : 6" :class="{ 'margin-top-documentos mobile-layout': isMobile }">
          <table>
            <tr>
              <td>
                <span class="texto-link">Baixar ficha cadastral</span>
              </td>
              <td class="alinhamento-doc1">
                <a :href="documentoFichaCadastralPF" target="_blank">
                  <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20.377" cy="20.377" r="20.377" fill="#E7E7E8" />
                    <path d="M20.3769 20.4983C21.2454 20.4983 22.0784 20.1485 22.6926 19.5258C23.3067 18.9031 23.6518 18.0586 23.6518 17.178C23.6518 16.2973 23.3067 15.4528 22.6926 14.8301C22.0784 14.2074 21.2454 13.8576 20.3769 13.8576C19.5083 13.8576 18.6754 14.2074 18.0612 14.8301C17.447 15.4528 17.102 16.2973 17.102 17.178C17.102 18.0586 17.447 18.9031 18.0612 19.5258C18.6754 20.1485 19.5083 20.4983 20.3769 20.4983ZM22.5601 17.178C22.5601 17.765 22.3301 18.3281 21.9207 18.7432C21.5112 19.1583 20.9559 19.3915 20.3769 19.3915C19.7979 19.3915 19.2425 19.1583 18.8331 18.7432C18.4237 18.3281 18.1936 17.765 18.1936 17.178C18.1936 16.5909 18.4237 16.0279 18.8331 15.6127C19.2425 15.1976 19.7979 14.9644 20.3769 14.9644C20.9559 14.9644 21.5112 15.1976 21.9207 15.6127C22.3301 16.0279 22.5601 16.5909 22.5601 17.178ZM26.9266 26.0322C26.9266 27.139 25.835 27.139 25.835 27.139H14.9188C14.9188 27.139 13.8271 27.139 13.8271 26.0322C13.8271 24.9254 14.9188 21.6051 20.3769 21.6051C25.835 21.6051 26.9266 24.9254 26.9266 26.0322ZM25.835 26.0278C25.8339 25.7555 25.6669 24.9365 24.9268 24.1861C24.215 23.4645 22.8756 22.7119 20.3769 22.7119C17.8771 22.7119 16.5387 23.4645 15.827 24.1861C15.0869 24.9365 14.921 25.7555 14.9188 26.0278H25.835Z" class="cor-estilo-desenho" />
                  </svg>
                </a>
              </td>
              <td class="alinhamento-doc2" v-if="!isPf()">
                <a :href="documentoFichaCadastralPJ" target="_blank">
                  <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="21.1309" cy="20.377" r="20.377" fill="#E7E7E8" />
                    <g clip-path="url(#clip0_4295_9552)">
                      <path d="M15.6401 13.1382C15.7426 13.0167 15.8698 12.9192 16.013 12.8523C16.1562 12.7854 16.312 12.7508 16.4697 12.7508H25.7922C25.9498 12.7508 26.1056 12.7854 26.2489 12.8523C26.3921 12.9192 26.5193 13.0167 26.6218 13.1382L29.4698 16.5073C29.7241 16.8081 29.8639 17.1913 29.8639 17.5875V17.8697C29.864 18.4175 29.6952 18.9517 29.3812 19.3975C29.0672 19.8434 28.6237 20.1786 28.1126 20.3564C27.6015 20.5341 27.0484 20.5456 26.5306 20.389C26.0128 20.2325 25.5562 19.9159 25.2245 19.4834C24.9823 19.7997 24.672 20.0556 24.3172 20.2315C23.9624 20.4074 23.5727 20.4987 23.1777 20.4983C22.7828 20.4988 22.393 20.4075 22.0382 20.2316C21.6834 20.0557 21.3731 19.7997 21.1309 19.4834C20.8888 19.7997 20.5785 20.0557 20.2237 20.2316C19.8689 20.4075 19.4791 20.4988 19.0841 20.4983C18.6892 20.4988 18.2994 20.4075 17.9446 20.2316C17.5898 20.0557 17.2795 19.7997 17.0373 19.4834C16.7057 19.9159 16.2491 20.2325 15.7313 20.389C15.2135 20.5456 14.6604 20.5341 14.1493 20.3564C13.6382 20.1786 13.1946 19.8434 12.8806 19.3975C12.5667 18.9517 12.3979 18.4175 12.3979 17.8697V17.5875C12.398 17.1913 12.5377 16.8081 12.792 16.5073L15.6412 13.1371L15.6401 13.1382ZM17.5832 17.8697C17.5832 18.2733 17.7413 18.6604 18.0228 18.9458C18.3043 19.2312 18.6861 19.3915 19.0841 19.3915C19.4822 19.3915 19.864 19.2312 20.1455 18.9458C20.427 18.6604 20.5851 18.2733 20.5851 17.8697C20.5851 17.7229 20.6426 17.5822 20.745 17.4784C20.8473 17.3746 20.9862 17.3163 21.1309 17.3163C21.2757 17.3163 21.4145 17.3746 21.5169 17.4784C21.6192 17.5822 21.6767 17.7229 21.6767 17.8697C21.6767 18.2733 21.8349 18.6604 22.1164 18.9458C22.3979 19.2312 22.7796 19.3915 23.1777 19.3915C23.5758 19.3915 23.9576 19.2312 24.2391 18.9458C24.5206 18.6604 24.6787 18.2733 24.6787 17.8697C24.6787 17.7229 24.7362 17.5822 24.8386 17.4784C24.9409 17.3746 25.0798 17.3163 25.2245 17.3163C25.3693 17.3163 25.5081 17.3746 25.6105 17.4784C25.7128 17.5822 25.7703 17.7229 25.7703 17.8697C25.7703 18.2733 25.9285 18.6604 26.21 18.9458C26.4914 19.2312 26.8732 19.3915 27.2713 19.3915C27.6694 19.3915 28.0512 19.2312 28.3327 18.9458C28.6142 18.6604 28.7723 18.2733 28.7723 17.8697V17.5875C28.7723 17.4556 28.7258 17.328 28.6413 17.2278L25.7922 13.8576H16.4697L13.6206 17.2278C13.536 17.328 13.4896 17.4556 13.4896 17.5875V17.8697C13.4896 18.2733 13.6477 18.6604 13.9292 18.9458C14.2107 19.2312 14.5925 19.3915 14.9906 19.3915C15.3886 19.3915 15.7704 19.2312 16.0519 18.9458C16.3334 18.6604 16.4915 18.2733 16.4915 17.8697C16.4915 17.7229 16.549 17.5822 16.6514 17.4784C16.7538 17.3746 16.8926 17.3163 17.0373 17.3163C17.1821 17.3163 17.3209 17.3746 17.4233 17.4784C17.5257 17.5822 17.5832 17.7229 17.5832 17.8697ZM14.0354 21.0517C14.1801 21.0517 14.319 21.11 14.4213 21.2138C14.5237 21.3176 14.5812 21.4583 14.5812 21.6051V28.2458H15.6728V22.7119C15.6728 22.4183 15.7878 22.1368 15.9925 21.9293C16.1973 21.7217 16.4749 21.6051 16.7644 21.6051H20.0393C20.3288 21.6051 20.6065 21.7217 20.8112 21.9293C21.0159 22.1368 21.1309 22.4183 21.1309 22.7119V28.2458H27.6807V21.6051C27.6807 21.4583 27.7382 21.3176 27.8405 21.2138C27.9429 21.11 28.0817 21.0517 28.2265 21.0517C28.3712 21.0517 28.5101 21.11 28.6124 21.2138C28.7148 21.3176 28.7723 21.4583 28.7723 21.6051V28.2458H29.3181C29.4629 28.2458 29.6017 28.3041 29.7041 28.4079C29.8064 28.5117 29.8639 28.6524 29.8639 28.7992C29.8639 28.946 29.8064 29.0867 29.7041 29.1905C29.6017 29.2943 29.4629 29.3526 29.3181 29.3526H12.9438C12.799 29.3526 12.6602 29.2943 12.5578 29.1905C12.4555 29.0867 12.3979 28.946 12.3979 28.7992C12.3979 28.6524 12.4555 28.5117 12.5578 28.4079C12.6602 28.3041 12.799 28.2458 12.9438 28.2458H13.4896V21.6051C13.4896 21.4583 13.5471 21.3176 13.6494 21.2138C13.7518 21.11 13.8906 21.0517 14.0354 21.0517ZM16.7644 28.2458H20.0393V22.7119H16.7644V28.2458ZM22.2226 22.7119C22.2226 22.4183 22.3376 22.1368 22.5423 21.9293C22.747 21.7217 23.0247 21.6051 23.3142 21.6051H25.4974C25.7869 21.6051 26.0646 21.7217 26.2693 21.9293C26.474 22.1368 26.589 22.4183 26.589 22.7119V26.0322C26.589 26.3258 26.474 26.6073 26.2693 26.8149C26.0646 27.0224 25.7869 27.139 25.4974 27.139H23.3142C23.0247 27.139 22.747 27.0224 22.5423 26.8149C22.3376 26.6073 22.2226 26.3258 22.2226 26.0322V22.7119ZM25.4974 22.7119H23.3142V26.0322H25.4974V22.7119Z" class="cor-estilo-desenho" />
                    </g>
                    <defs>
                      <clipPath id="clip0_4295_9552">
                        <rect width="17.466" height="17.7086" fill="white" transform="translate(12.3979 11.644)" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </td>
            </tr>
          </table>
        </v-col>

        <v-col :cols="isMobile ? 12 : 6" v-if="isStara" :class="isMobile ? 'margin-top-documentos mobile-layout': 'div-documentos'">
          <table>
            <tr>
              <td><span class="texto-link">Baixar ficha de análise de crédito</span></td>
              <td class="alinhamento-doc2">
                <a :href="srcCriterios" target="_blank">
                  <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20.377" cy="20.377" r="20.377" fill="#E7E7E8" />
                    <g clip-path="url(#clip0_4297_5255)">
                      <path d="M11.9174 22.6011C12.0622 22.6011 12.201 22.6594 12.3033 22.7632C12.4057 22.8669 12.4632 23.0077 12.4632 23.1545V25.9214C12.4632 26.215 12.5782 26.4965 12.7829 26.704C12.9877 26.9116 13.2653 27.0282 13.5548 27.0282H26.6543C26.9438 27.0282 27.2215 26.9116 27.4262 26.704C27.6309 26.4965 27.7459 26.215 27.7459 25.9214V23.1545C27.7459 23.0077 27.8034 22.8669 27.9058 22.7632C28.0082 22.6594 28.147 22.6011 28.2917 22.6011C28.4365 22.6011 28.5753 22.6594 28.6777 22.7632C28.78 22.8669 28.8376 23.0077 28.8376 23.1545V25.9214C28.8376 26.5085 28.6075 27.0715 28.1981 27.4867C27.7887 27.9018 27.2333 28.135 26.6543 28.135H13.5548C12.9758 28.135 12.4205 27.9018 12.011 27.4867C11.6016 27.0715 11.3716 26.5085 11.3716 25.9214V23.1545C11.3716 23.0077 11.4291 22.8669 11.5314 22.7632C11.6338 22.6594 11.7726 22.6011 11.9174 22.6011Z" class="cor-estilo-desenho" />
                      <path d="M19.7181 24.7637C19.7688 24.8153 19.8291 24.8562 19.8954 24.8841C19.9617 24.912 20.0328 24.9263 20.1046 24.9263C20.1764 24.9263 20.2475 24.912 20.3138 24.8841C20.3801 24.8562 20.4403 24.8153 20.491 24.7637L23.7659 21.4434C23.8684 21.3395 23.9259 21.1985 23.9259 21.0516C23.9259 20.9046 23.8684 20.7637 23.7659 20.6598C23.6634 20.5559 23.5244 20.4975 23.3794 20.4975C23.2345 20.4975 23.0955 20.5559 22.993 20.6598L20.6504 23.0361V13.3041C20.6504 13.1573 20.5929 13.0166 20.4905 12.9128C20.3882 12.809 20.2493 12.7507 20.1046 12.7507C19.9598 12.7507 19.821 12.809 19.7186 12.9128C19.6163 13.0166 19.5588 13.1573 19.5588 13.3041V23.0361L17.2161 20.6598C17.1136 20.5559 16.9746 20.4975 16.8297 20.4975C16.6848 20.4975 16.5458 20.5559 16.4433 20.6598C16.3408 20.7637 16.2832 20.9046 16.2832 21.0516C16.2832 21.1985 16.3408 21.3395 16.4433 21.4434L19.7181 24.7637Z" class="cor-estilo-desenho" />
                    </g>
                    <defs>
                      <clipPath id="clip0_4297_5255">
                        <rect width="17.466" height="17.7086" fill="white" transform="translate(11.3716 11.6439)" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </td>
            </tr>
          </table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import session from '../../plugins/session'

  export default {
    name: 'CardBaixarDocumentos',
    props: {
      fase: {
        type: Object,
        required: true
      },
      cliente: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      srcCriterios: '/CriteriosdeAnalise.pdf',
      srcDocumentos: '/DocumentacoesPF.pdf',
      documentoFichaCadastralPF: '/FichaCadastralPF.pdf',
      documentoFichaCadastralPJ: '/FichaCadastralPJ.pdf',
      documentoFichaAnaliseCredito: '/FichaCadastralPJ.pdf',
      isStara: false
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
      }
    },
    mounted () {
      if (!this.isPf()) {
        this.srcDocumentos = '/DocumentacoesPJ.pdf'
      }

      const unidade = session.get('unidade')

      if (unidade.idUnidade === 44) {
        this.srcCriterios = '/FormularioCriteriosdeAnalise_Stara.pdf'
        this.srcDocumentos = '/CriteriosdeAnalise_Stara.pdf'
        this.documentoFichaCadastralPF = '/FichaCadastralPF_Stara.pdf'
        this.documentoFichaCadastralPJ = '/FichaCadastralPJ_Stara.pdf'
        this.isStara = true
      }
    },
    methods: {
      isPf () {
        return this.cliente?.cpfCnpj?.replaceAll('.', '').replace('-', '').length === 11
      }
    }
  }
</script>

<style scoped>

.alinhamento-doc1 {
  padding-left: 11px;
}

.alinhamento-doc2 {
  padding-left: 12px;
}

.texto-link {
  color:#191E26;
  /* Legenda/Legenda bold */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700; /* 18px */
}

.cor-estilo-desenho {
  fill: var(--primaria, #191E26);
}

.margin-top-documentos {
  padding-top: 5px;
  padding-left: 0px;
  padding-bottom: 0px;
}

.div-documentos {
  display: flex;
  justify-content: right;
}
.mobile-layout table {
  width: 100%;
}

.mobile-layout td:last-child {
  text-align: right;
}
.mobile-layout td:last-child a {
  margin-right: -24px;
}
@media screen and (max-width: 960px){
  /*  */
}
</style>
